<div *ngIf="formType === 'coverpath'">
  I, {{ receivedPaymentInfo.payerName }}, authorize the {{ receivedPaymentInfo.company }} Life Insurance Company (“the
  Company”) to debit {{ receivedPaymentInfo.paymentAmount.valueOf() | currency: 'USD':true }} on {{ frequency }} basis
  beginning on {{ receivedPaymentInfo.effectiveDraftDate | date }} from my financial institution via Electronic Funds
  Transfer (EFT). This authorization will remain in effect until the Company receives notification of termination. I may
  revoke this authorization by emailing DigitalCustomerSupport@massmutual.com or calling 1-866-618-7797.
</div>

<div *ngIf="formType === 'haven'">
  I, {{ receivedPaymentInfo.payerName }}, authorize the {{ receivedPaymentInfo.company }} Life Insurance Company (“the
  Company”) to debit {{ receivedPaymentInfo.paymentAmount.valueOf() | currency: 'USD':true }} effective
  {{ receivedPaymentInfo.effectiveDraftDate | date }} from my financial institution via Electronic Funds Transfer (EFT).
  This authorization will remain in effect until the Company receives notification of termination. I may revoke this
  authorization by emailing help@havenlife.com or calling 1-855-744-2836.
</div>

<div *ngIf="formType === 'mmdirect'">
  I, {{ receivedPaymentInfo.payerName }}, authorize the {{ receivedPaymentInfo.company }} Life Insurance Company (“the
  Company”) to debit {{ receivedPaymentInfo.paymentAmount.valueOf() | currency: 'USD':true }} on {{ frequency }} basis
  beginning on {{ receivedPaymentInfo.effectiveDraftDate | date }} from my financial institution via Electronic Funds
  Transfer (EFT). This authorization will remain in effect until the Company receives notification of termination. I may
  revoke this authorization by emailing supportDirectTerm@massmutual.com or calling 1-844-611-1027.
</div>
